import { withFeatureFlags } from '.';

const FeatureFlagged = ({ featureFlags, only, except, children }) => {
  if (only && !only.some(flag => featureFlags.indexOf(flag) > -1)) {
    return null;
  }

  if (except && except.some(flag => featureFlags.indexOf(flag) > -1)) {
    return null;
  }

  return children;
};

export default withFeatureFlags(FeatureFlagged);
